import type { DomainMapper } from '../types';

const base = {
  countryCode: 'fi',
  currency: 'EUR',
  dataAreaId: 'fi50',
  environment: 'production',
  flagUrl: '/flags/FI.svg',
  languagePrimary: true,
  locale: 'fi',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'tuote',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fi.xml',
  storyblokBasePath: 'fi',
  algoliaIndex: 'b2b-fi-fi-FI-products',
  algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1358,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1358,
    algoliaIndex: 'b2b-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2b-fi-fi-FI-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/tuote',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fi.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1475,
    algoliaIndex: 'b2c-fi-fi-FI-products',
    algoliaIndexAutocomplete: 'b2c-fi-fi-FI-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'tuote',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-fi-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    sampleRequestNav: true,
  },
  showNonPublicProducts: false,
};

const fi: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default fi;
